import { hasOwnProperty } from 'shared/lib'

const toCamelCase = (str: string) =>
  str.replace(/([_][a-z])/gi, (match) => match.toUpperCase().replace('_', ''))

export const keysToCamelCase = (
  obj: Record<string, any>,
): Record<string, any> => {
  if (Array.isArray(obj)) {
    return obj.map((item) => keysToCamelCase(item))
  } else if (obj !== null && typeof obj === 'object') {
    const newObj: Record<string, any> = {}

    for (const key in obj) {
      if (hasOwnProperty(obj, key)) {
        const camelCasedKey = toCamelCase(key)

        newObj[camelCasedKey] = keysToCamelCase(obj[key])
      }
    }

    return newObj
  }

  return obj
}
